import * as d3 from 'd3';
import * as _ from 'underscore';
//import FacemappingApi from '../api/FacemappingApi';
import FileApi from '../api/FileApi';
import { FILE_URL } from '../const';

export default function FacemappingCanvasHelper() {
    var exports = {};

    //var frontImageOriginUrl = '';
    //var frontImageOrigin = '';

    /*****************************************************************
     * constants & variables
     */
    /* constants */
    var VERSION = '1.0';
    var ACTION_ADD = 'add';
    var ACTION_REMOVE = 'remove';
    var TARGET_JOINT = 'joint';
    var TARGET_ROCK = 'rock';
    var TARGET_WATER = 'water';
    var TARGET_TEXT = 'text';
    /* [2021/03/27] 암종 */
    var TARGET_TYPE = 'type';

    /* [2025/05/25] 자유선 */
    var TARGET_FREELINE = 'freeline';

    /* */
    var JOINT_LINE_WIDTH = 2;
    var JOINT_RECTANGLE_WIDTH = 10;
    var ROCK_TRANSPARENT_OPACITY = 0.3;
    var WATER_ICON_SIZE = 42;
    var TEXT_FONT_SIZE = '2em';
    var TEXT_FONT_COLOR = 'black';
    var TEXT_FONT_ANCHOR = 'middle';

    /* [2021/03/27] 암종 */
    var DEFAULT_TYPE_COLOR = 'gray';
    var ROCK_TRANSPARENT_OPACITY_ROW = 0.6;

    /* [2025/05/25] added, 자유선 그리기 */
    var FREELINE_DEFAULT_STROKE_WIDTH = 2;
    var FREELINE_TRANSPARENT_OPACITY = 0.5;

    /* end of [2025/05/25] */
    /* */
    var apiResponse = {
        imgurl: '../assets/images/sample/sample-1.jpg'
    };

    /* ---------------------------------------------------- */
    /* [2023/12/13] 개별 지질면, 막장면 정의 */
    /* database */
    var joints = [];
    var rocks = [];
    var waters = [];
    var texts = [];
    /* [2021/03/27] 암종 */
    var types = [];

    /* [2025/05/25] added, 자유선 그리기 */
    var freelines = [];

    /* */
    var undoHistories = [];
    var redoHistories = [];

    /* related to d3 */
    var svg = null;
    var rootLayer = null;
    var background = null;
    var canvas = null;
    var tempcanvas = null;

    /* 암종 패턴 정의 */
    var defs = null;

    // var imageRect = {
    //     top: 0,
    //     left: 0,
    //     width: 0,
    //     height: 0,
    //     scaleX: 1,
    //     scaleY: 1
    // };

    /* d3 control */
    var requestDrawJoint = false;
    var requestJointColor = 'black';
    var startJointPoint = null;
    /* */
    var requestDrawRock = false;
    var requestRockColor = 'black';
    var startRockPoints = [];

    /* [2021/03/27] 암종 */
    var requestDrawType = false;
    var requestTypePattern = 'granite';
    var startTypePoints = [];

    /* */
    var requestDrawWater = false;
    var requestWaterIcon = 'damp';

    /* */
    var requestDrawText = false;
    var requestRemoveObject = false;

    /* [2025/05/25] added, 자유선그리기 */
    var requestFreeLineType = false;
    var requestFreeLineWidth = FREELINE_DEFAULT_STROKE_WIDTH;
    var requestFreeLineColor = 'black';
    var startFreeLinePoints = [];

    var rockJudgmentName = '';
    var masterId = null;

    /* [2021/03/27] */
    var rootSelector = 'body';
    var onChangedZoomEnable = null;
    var onChangedEraseEnable = null;
    var onReleaseRequestOperation = null;
    var isKeepSelectedOperation = false;
    var textFontSize = null;
    var textFontColor = null;
    var textAutoText = '';

    /* [2024/06/17] */
    var typePatternPrefix = '';

    /*****************************************************************
     * Img URL To Base64 Data URL
     */
    /* */
    function convertImgURLToDataURL(imgurl, callback) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function() {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var dataURL;

            canvas.height = this.height;
            canvas.width = this.width;
            ctx.drawImage(this, 0, 0);
            dataURL = canvas.toDataURL();
            if (_.isFunction(callback)) {
                callback(dataURL, this.width, this.height);
            }
            canvas = null;
        };
        img.src = imgurl;
    }

    /*
     * 현, SVG의 BASE64 IMAGE DATA를 얻는 함수
     */
    function getImageBase64OfCurrentSvg() {
        var $svg = $(rootSelector + ' svg');
        // Serialize svg to string
        var svgString = new XMLSerializer().serializeToString($svg[0]);

        // // Firefox, Safari root NS issue fix
        // svgString = svgString.replace('xlink=', 'xmlns:xlink=');
        // // Safari xlink NS issue fix
        // svgString = svgString.replace(/NS\d+:href/gi, 'xlink:href');

        // Remove any characters outside the Latin1 range
        var decoded = unescape(encodeURIComponent(svgString));

        // Now we can use btoa to convert the svg to base64
        var base64 = btoa(decoded);
        //base64 = `data:image/assets/images/svg+xml;base64,${base64}`;
        base64 = `data:image/svg+xml;base64,${base64}`;

        /*
         * $('img').attr('src', base64);
         */
        //$('#base64_img').attr('src', base64);

        /* */
        return base64;
    }

    function base64ToBlob(data) {
        let mimeString = '';
        let raw, uInt8Array, i;
        const rImageType = /data:(image\/.+);base64,/;

        raw = data.replace(rImageType, function(header, imageType) {
            mimeString = imageType;
            return '';
        });

        raw = atob(raw);
        const rawLength = raw.length;
        uInt8Array = new Uint8Array(rawLength); // eslint-disable-line
        for (i = 0; i < rawLength; i += 1) {
            uInt8Array[i] = raw.charCodeAt(i);
        }
        return new Blob([uInt8Array], {
            type: mimeString
        });
    }

    function svgUrlToPng(svgUrl, callback) {
        const svgImage = document.createElement('img');
        svgImage.style.position = 'absolute';
        svgImage.style.top = '-9999px';
        document.body.appendChild(svgImage);
        svgImage.onload = function() {
            const canvas = document.createElement('canvas');
            canvas.width = svgImage.clientWidth;
            canvas.height = svgImage.clientHeight;
            const canvasCtx = canvas.getContext('2d');
            canvasCtx.drawImage(svgImage, 0, 0);
            const imgData = canvas.toDataURL('image/png');
            callback(imgData);
            // document.body.removeChild(imgPreview);
        };
        svgImage.src = svgUrl;
    }

    function svgUrlToGsPng(svgUrl, callback) {
        const svgImage = document.createElement('img');
        svgImage.style.position = 'absolute';
        svgImage.style.top = '-9999px';
        document.body.appendChild(svgImage);
        svgImage.onload = function() {
            var sx = (900 - 870) / 2;
            var sy = (250 - 225) / 2;

            const canvas = document.createElement('canvas');
            canvas.width = 880;
            canvas.height = 230;
            const canvasCtx = canvas.getContext('2d');
            canvasCtx.fillStyle = '#FFFFFF'; // 흰색으로 fillStyle 설정
            canvasCtx.fillRect(0, 0, canvas.width, canvas.height);
            canvasCtx.drawImage(svgImage, sx, sy, 870, 225, 0, 0, 880, 230);
            const imgData = canvas.toDataURL('image/png');
            //document.getElementById('base64image').src = imgData;
            callback(imgData);
            // document.body.removeChild(imgPreview);
        };
        svgImage.src = svgUrl;
    }

    /* */
    function isNullEmpty(value) {
        if (_.isNumber(value)) return false;
        if (
            _.isUndefined(value) ||
            _.isNull(value) ||
            _.isEmpty(value) ||
            (_.isArray(value) && value.length === 0) ||
            value === 'undefined'
        ) {
            return true;
        }

        return false;
    }

    /* 두점간의 각도 */
    function getAngle(x1, y1, x2, y2) {
        var rad = Math.atan2(y2 - y1, x2 - x1);
        return (rad * 180) / Math.PI;
    }

    /* */
    function getCenter(x1, y1, x2, y2) {
        var centerX = (x1 + x2) / 2.0;
        var centerY = (y1 + y2) / 2.0;

        return {
            x: centerX,
            y: centerY
        };
    }

    /*
     * 두점이 주어질 경우, 수평을 기준으로 센터에 BOX를 구한다. 추후, Rotation시킬 예정
     */
    function getJointRectangle(x1, y1, x2, y2) {
        var centerX = (x1 + x2) / 2.0;
        var centerY = (y1 + y2) / 2.0;

        var points = [];

        points.push({
            x: centerX - JOINT_RECTANGLE_WIDTH / 2.0,
            y: centerY
        });
        points.push({
            x: centerX - JOINT_RECTANGLE_WIDTH / 2.0,
            y: centerY + JOINT_RECTANGLE_WIDTH
        });
        points.push({
            x: centerX + JOINT_RECTANGLE_WIDTH / 2.0,
            y: centerY + JOINT_RECTANGLE_WIDTH
        });
        points.push({
            x: centerX + JOINT_RECTANGLE_WIDTH / 2.0,
            y: centerY
        });

        // console.log("[*] (" + x1 + "," + y1 + ") - (" + x2 + "," + y2 + ")");
        // console.log("[*] center (" + centerX + "," + centerY + ")");
        // console.log("[*] point :", points);

        return points;
    }

    /*****************************************************************
     * Database
     */
    function getUUID() {
        // UUID v4 generator in JavaScript (RFC4122 compliant)
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 3) | 8;
            return v.toString(16);
        });
    }

    /* */
    function appendToHistoryDb(history) {
        /* */
        if (_.isObject(history)) {
            undoHistories.push(history);
        }
    }

    /* JOINT DB */
    function appendToJointDb(joint, noHistory) {
        joints.push(joint);

        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_ADD,
                target: TARGET_JOINT,
                data: $.extend({}, joint)
            });
        }
    }

    /* */
    function removeJointDbBy(rmId, noHistory) {
        var index = _.findIndex(joints, function(joint) {
            return joint.id === rmId;
        });
        if (index === -1) return;

        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_REMOVE,
                target: TARGET_JOINT,
                data: $.extend({}, joints[index])
            });
        }

        /* */
        joints.splice(index, 1);
    }

    /* ROCK DB */
    function appendToRockDb(rock, noHistory) {
        rocks.push(rock);
        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_ADD,
                target: TARGET_ROCK,
                data: $.extend({}, rock)
            });
        }
    }

    /* */
    function removeRockDbBy(rmId, noHistory) {
        var index = _.findIndex(rocks, function(rock) {
            return rock.id === rmId;
        });
        if (index === -1) return;

        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_REMOVE,
                target: TARGET_ROCK,
                data: $.extend({}, rocks[index])
            });
        }

        /* */
        rocks.splice(index, 1);
    }

    /* WATER DB */
    function appendToWaterDb(water, noHistory) {
        waters.push(water);
        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_ADD,
                target: TARGET_WATER,
                data: $.extend({}, water)
            });
        }
    }

    /* */
    function removeWaterDbBy(rmId, noHistory) {
        var index = _.findIndex(waters, function(water) {
            return water.id === rmId;
        });
        if (index === -1) return;

        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_REMOVE,
                target: TARGET_WATER,
                data: $.extend({}, waters[index])
            });
        }

        /* */
        waters.splice(index, 1);
    }

    /* TEXT DB */
    function appendToTextDb(text, noHistory) {
        texts.push(text);
        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_ADD,
                target: TARGET_TEXT,
                data: $.extend({}, text)
            });
        }
    }

    /* */
    function removeTextDbBy(rmId, noHistory) {
        var index = _.findIndex(texts, function(text) {
            return text.id === rmId;
        });
        if (index === -1) return;

        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_REMOVE,
                target: TARGET_TEXT,
                data: $.extend({}, texts[index])
            });
        }

        /* */
        texts.splice(index, 1);
    }

    /* [2021/03/27] 암종 TYPE DB */
    function appendToTypeDb(type, noHistory) {
        types.push(type);
        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_ADD,
                target: TARGET_TYPE,
                data: $.extend({}, type)
            });
        }
    }

    /* */
    function removeTypeDbBy(rmId, noHistory) {
        var index = _.findIndex(types, function(type) {
            return type.id === rmId;
        });
        if (index === -1) return;

        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_REMOVE,
                target: TARGET_TYPE,
                data: $.extend({}, types[index])
            });
        }

        /* */
        types.splice(index, 1);
    }

    /* [2025/05/25] added */
    /* FREELINE DB */
    function appendToFreeLineDb(freeline, noHistory) {
        freelines.push(freeline);
        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_ADD,
                target: TARGET_FREELINE,
                data: $.extend({}, freeline)
            });
        }
    }

    /* */
    function removeFreeLineDbBy(rmId, noHistory) {
        var index = _.findIndex(freelines, function(freeline) {
            return freeline.id === rmId;
        });
        if (index === -1) return;

        /* */
        if (noHistory !== true) {
            appendToHistoryDb({
                action: ACTION_REMOVE,
                target: TARGET_FREELINE,
                data: $.extend({}, freelines[index])
            });
        }

        /* */
        freelines.splice(index, 1);
    }
    /* end of [2025/05/25] */

    /* */
    function doUndoOnHistoryDb() {
        var hist = undoHistories.pop();
        /* */
        if (hist) {
            if (hist.action === ACTION_ADD) {
                if (hist.target === TARGET_JOINT) {
                    removeJointDbBy(hist.data.id, true);
                } else if (hist.target === TARGET_ROCK) {
                    removeRockDbBy(hist.data.id, true);
                } else if (hist.target === TARGET_WATER) {
                    removeWaterDbBy(hist.data.id, true);
                } else if (hist.target === TARGET_TEXT) {
                    removeTextDbBy(hist.data.id, true);
                } else if (hist.target === TARGET_TYPE) {
                    /* [2021/03/27] 암종 */
                    removeTypeDbBy(hist.data.id, true);
                } else if (hist.target === TARGET_FREELINE) {
                    /* [2025/05/25] added */
                    removeFreeLineDbBy(hist.data.id, true);
                }
            } else if (hist.action === ACTION_REMOVE) {
                if (hist.target === TARGET_JOINT) {
                    appendToJointDb(hist.data, true);
                } else if (hist.target === TARGET_ROCK) {
                    appendToRockDb(hist.data, true);
                } else if (hist.target === TARGET_WATER) {
                    appendToWaterDb(hist.data, true);
                } else if (hist.target === TARGET_TEXT) {
                    appendToTextDb(hist.data, true);
                } else if (hist.target === TARGET_TYPE) {
                    /* [2021/03/27] 암종 */
                    appendToTypeDb(hist.data, true);
                } else if (hist.target === TARGET_FREELINE) {
                    /* [2025/05/25] added */
                    appendToFreeLineDb(hist.data, true);
                }
            }

            /* */
            redoHistories.push(hist);
        }
    }

    /* */
    function doRedoOnHistoryDb() {
        var hist = redoHistories.pop();

        //console.log("[*] redo:", hist);
        /* */
        if (hist) {
            if (hist.action === ACTION_REMOVE) {
                if (hist.target === TARGET_JOINT) {
                    removeJointDbBy(hist.data.id, true);
                } else if (hist.target === TARGET_ROCK) {
                    removeRockDbBy(hist.data.id, true);
                } else if (hist.target === TARGET_WATER) {
                    removeWaterDbBy(hist.data.id, true);
                } else if (hist.target === TARGET_TEXT) {
                    removeTextDbBy(hist.data.id, true);
                } else if (hist.target === TARGET_TYPE) {
                    /* [2021/03/27] 암종 */
                    removeTypeDbBy(hist.data.id, true);
                } else if (hist.target === TARGET_FREELINE) {
                    /* [2025/05/25] added */
                    removeFreeLineDbBy(hist.data.id, true);
                }
            } else if (hist.action === ACTION_ADD) {
                if (hist.target === TARGET_JOINT) {
                    appendToJointDb(hist.data, true);
                } else if (hist.target === TARGET_ROCK) {
                    appendToRockDb(hist.data, true);
                } else if (hist.target === TARGET_WATER) {
                    appendToWaterDb(hist.data, true);
                } else if (hist.target === TARGET_TEXT) {
                    appendToTextDb(hist.data, true);
                } else if (hist.target === TARGET_TYPE) {
                    /* [2021/03/27] 암종 */
                    appendToTypeDb(hist.data, true);
                } else if (hist.target === TARGET_FREELINE) {
                    /* [2025/05/25] added */
                    appendToFreeLineDb(hist.data, true);
                }
            }

            /* */
            undoHistories.push(hist);
        }
    }

    /* */
    function clearDbAll() {
        joints = [];
        rocks = [];
        waters = [];
        texts = [];

        /* [2021/03/27] 암종 */
        types = [];

        /* [2025/05/25] 자유선 */
        freelines = [];

        undoHistories = [];
        redoHistories = [];
    }

    /* */
    function dumpDbAll() {
        return {
            version: VERSION,
            joints: joints,
            rocks: rocks,
            waters: waters,
            texts: texts,
            /* [2021/03/27] 암종 */
            types: types,
            /* [2025/05/25] 자유선 */
            freelines: freelines
        };
    }

    /* [2024/05/25] modified, added facemappingType (FM, GS) */
    function restoreDb(db, facemappingType) {
        clearDbAll();
        if (!isNullEmpty(db)) {
            if (facemappingType === 'GS') {
                joints = db.joints4gs || [];
                rocks = db.rocks4gs || [];
                waters = db.waters4gs || [];
                texts = db.texts4gs || [];
                /* [2021/03/27] 암종 */
                types = db.types4gs || [];

                /* [2025/05/25] 자유선 */
                freelines = db.freelines4gs || [];
                /* freelines4gs */
            } else {
                /* FM */
                joints = db.joints || [];
                rocks = db.rocks || [];
                waters = db.waters || [];
                texts = db.texts || [];
                /* [2021/03/27] 암종 */
                types = db.types || [];

                /* [2025/05/25] 자유선 */
                freelines = db.freelines || [];
                /* freelines */
            }
        }
    }

    /*****************************************************************
     * D3
     */
    /* [2024/05/25] modified, added facemappingType (FM, GS) */
    function initData(data, facemappingType) {
        rockJudgmentName = data.station;
        if (facemappingType === 'FM') apiResponse.imgurl = data.frontImageUrl ? FILE_URL + data.frontImageUrl : null;

        console.log('[*] image url:' + apiResponse.imgurl);
        console.log('[*] facemappingType:' + facemappingType);

        restoreDb(JSON.parse(data.rockJudgmentObj), facemappingType);
        redrawCanvas();
    }

    /* */
    function initD3() {
        /* 수정 예정 */
        //var width = window.innerWidth;
        //var height = window.innerHeight;

        var width = $(rootSelector)
            .parent()
            .width();

        var height = $(rootSelector)
            .parent()
            .height();

        console.log('[*] d3:' + rootSelector + ', width:' + width + ', height:' + height);

        /* */
        svg = d3
            .select(rootSelector)
            .append('svg')
            .attr('width', width)
            .attr('height', height)
            .call(
                d3
                    .zoom()
                    .scaleExtent([0.5, 2])
                    /*
                    .filter(function() {
                        // only wheel
                        return !event.button && event.type === 'wheel';
                    })
                    */
                    .on('zoom', function() {
                        rootLayer.attr('transform', d3.event.transform);
                    })
            )
            .on('dblclick.zoom', null);

        /* 암종 패턴 정의 */
        defs = svg.append('defs');

        /* */
        rootLayer = svg.append('g');
        background = rootLayer.append('g');
        canvas = rootLayer.append('g');
        tempcanvas = rootLayer.append('g');

        if (rootSelector === '#id-d3-gs-container') {
            const innerWidth = width - 20;
            const innerHeight = height - 20;

            var cutSvgForGS = svg
                .append('svg')
                .attr('x', 10)
                .attr('y', 10)
                .attr('width', innerWidth)
                .attr('height', innerHeight);

            cutSvgForGS
                .append('rect')
                .attr('width', innerWidth)
                .attr('height', innerHeight)
                .attr('fill', 'none')
                .attr('stroke', 'red')
                .attr('stroke-width', 2);
        }

        /* event */

        svg.on(['mousedown, touchstart'], function(d) {
            onTouchStart(toTransformPoint(d3.mouse(this)));
        });

        svg.on(['mousemove, touchmove'], function(d) {
            onTouchMove(toTransformPoint(d3.mouse(this)));
        });

        svg.on(['mouseup, touchend'], function(d) {
            onTouchEnd(toTransformPoint(d3.mouse(this)));
        });

        loadRockTypePatterns();

        console.log('[*] d3 initialized');
    }

    /* zoom/tranform 좌표계 대응 원점을 찾는다. */
    function toTransformPoint(point) {
        var transform = d3.zoomTransform(rootLayer.node());
        return transform.invert(point);
    }

    /* */
    function enableZoom(enabled) {
        /* [2024/05/25] added */
        if (zoomOff === true) return;
        /* end of [2024/05/25] */

        if (_.isFunction(onChangedZoomEnable)) {
            /* */
            onChangedZoomEnable(enabled);
        }

        if (enabled) {
            svg.call(
                d3
                    .zoom()
                    .scaleExtent([0.3, 2])
                    /*
          .filter(function() {
              // only wheel
              return !event.button && event.type === 'wheel';
          })
          */
                    .on('zoom', function() {
                        rootLayer.attr('transform', d3.event.transform);
                    })
            ).on('dblclick.zoom', null);
        } else {
            svg.on('.zoom', null);
        }
    }

    /* [2024/05/25] added */
    var zoomOff = false;
    function disableZoomForcibly() {
        svg.on('.zoom', null);
        zoomOff = true;
    }
    /* end of [2024/05/25] */

    /* */
    function onTouchStart(point) {
        /* */
        if (requestDrawJoint === true) {
            /* 절리 그리기 */
            startJointPoint = point;
        } else if (requestDrawRock === true) {
            /* 암질 그리기 */
            var pt = point;
            /* */
            if (startRockPoints.length > 0) {
                var first = startRockPoints[0];

                //console.log("[*] first, pt :" , first, pt);
                /* 처음 시작점으로 돌아왔는지 확인 */
                if (Math.abs(first.x - pt[0]) < 5 && Math.abs(first.y - pt[1]) < 5) {
                    tempcanvas.selectAll('*').remove();

                    var rock = {
                        id: getUUID(),
                        color: requestRockColor,
                        points: startRockPoints
                    };

                    /* */
                    startRockPoints = [];

                    /* */
                    appendToRockDb(rock);
                    drawRock(rock);

                    /* */
                    releaseOperationIfNoKeep();

                    return;
                }
            }

            /* */
            startRockPoints.push({
                x: pt[0],
                y: pt[1]
            });

            /* */
            var circleColor = requestRockColor;
            var circleRadius = 2;
            if (startRockPoints.length === 1) {
                circleColor = 'red';
                circleRadius = 6;
            }

            tempcanvas.selectAll('polygon').remove();
            tempcanvas
                .append('circle')
                .attr('r', circleRadius)
                .style('stroke', circleColor)
                .style('stroke-width', JOINT_LINE_WIDTH)
                .attr('cx', pt[0])
                .attr('cy', pt[1]);

            tempcanvas
                .append('polygon')
                .style('stroke', requestRockColor)
                .style('stroke-width', JOINT_LINE_WIDTH)
                .style('fill', requestRockColor)
                .style('opacity', ROCK_TRANSPARENT_OPACITY)
                .attr('points', function() {
                    return startRockPoints
                        .map(function(d) {
                            return [d.x, d.y].join(',');
                        })
                        .join(' ');
                });
        } else if (requestDrawType === true) {
            /* 암종 그리기 */
            var pt = point;
            /* */
            if (startTypePoints.length > 0) {
                var first = startTypePoints[0];

                //console.log("[*] first, pt :" , first, pt);
                /* 처음 시작점으로 돌아왔는지 확인 */
                if (Math.abs(first.x - pt[0]) < 5 && Math.abs(first.y - pt[1]) < 5) {
                    tempcanvas.selectAll('*').remove();

                    var type = {
                        id: getUUID(),
                        pattern: requestTypePattern,
                        points: startTypePoints
                    };

                    /* */
                    startTypePoints = [];

                    /* */
                    appendToTypeDb(type);
                    drawType(type);

                    /* */
                    releaseOperationIfNoKeep();

                    return;
                }
            }

            /* */
            startTypePoints.push({
                x: pt[0],
                y: pt[1]
            });

            /* */
            circleRadius = 2;
            if (startTypePoints.length === 1) {
                circleColor = 'red';
                circleRadius = 6;
            }

            tempcanvas.selectAll('polygon').remove();
            tempcanvas
                .append('circle')
                .attr('r', circleRadius)
                .style('stroke', DEFAULT_TYPE_COLOR)
                .style('stroke-width', JOINT_LINE_WIDTH)
                .attr('cx', pt[0])
                .attr('cy', pt[1]);

            /* [2024/06/17] requestTypePattern to makeTypePatternId(requestTypePattern) */
            tempcanvas
                .append('polygon')
                .style('stroke', DEFAULT_TYPE_COLOR)
                .style('stroke-width', JOINT_LINE_WIDTH)
                .style('fill', 'url(#' + makeTypePatternId(requestTypePattern) + ')')
                .style('opacity', ROCK_TRANSPARENT_OPACITY_ROW)
                .attr('points', function() {
                    return startTypePoints
                        .map(function(d) {
                            return [d.x, d.y].join(',');
                        })
                        .join(' ');
                });
        } else if (requestDrawWater === true) {
            /* 지하수 그리기 */
            var water = {
                id: getUUID(),
                x: point[0],
                y: point[1],
                icon: requestWaterIcon
            };
            /* */
            appendToWaterDb(water);
            drawWater(water);

            /* */
            releaseOperationIfNoKeep();
        } else if (requestDrawText === true) {
            /* 지하수 그리기 */
            /* */
            tempcanvas.selectAll('*').remove();
            tempcanvas
                .append('circle')
                .attr('r', 10)
                .style('stroke', 'red')
                .style('fill', 'red')
                .style('stroke-width', JOINT_LINE_WIDTH)
                .attr('cx', point[0])
                .attr('cy', point[1]);

            /* */
            setTimeout(function() {
                /* */
                var message = '' + textAutoText;
                if (message.length === 0) {
                    message = prompt('텍스트값을 입력하세요.');
                }

                if (message) {
                    var fontSize = textFontSize || TEXT_FONT_SIZE;
                    var fontColor = textFontColor || TEXT_FONT_COLOR;

                    var text = {
                        id: getUUID(),
                        x: point[0],
                        y: point[1],
                        text: message,
                        fontSize: fontSize,
                        fontColor: fontColor
                    };
                    /* */
                    appendToTextDb(text);
                    drawText(text);

                    /* */
                    releaseOperationIfNoKeep();
                }
                tempcanvas.selectAll('*').remove();
            }, 100);
        } else if (requestFreeLineType === true) {
            /* [2025/05/25] added */
            /* */
            if (startFreeLinePoints.length > 0) {
                /* */
                tempcanvas.selectAll('polyline').remove();

                var freeline = {
                    id: getUUID(),
                    strokeWidth: requestFreeLineWidth,
                    strokeColor: requestFreeLineColor,
                    points: startFreeLinePoints
                };

                /* */
                appendToFreeLineDb(freeline);
                drawFreeLine(freeline);

                /* */
                releaseOperationIfNoKeep();
                return;
            }

            /* 자유선 그리기 */
            startFreeLinePoints = [];
            startFreeLinePoints.push({
                x: point[0],
                y: point[1]
            });

            /* */
            tempcanvas.selectAll('polyline').remove();
            tempcanvas
                .append('polyline')
                .style('stroke', requestFreeLineColor)
                .style('stroke-width', requestFreeLineWidth)
                .style('fill', 'transparent')
                .style('opacity', FREELINE_TRANSPARENT_OPACITY)
                .attr('points', function() {
                    return startFreeLinePoints
                        .map(function(d) {
                            return [d.x, d.y].join(',');
                        })
                        .join(' ');
                });
        }
        /* end of [2025/05/25] */
    }

    function onTouchMove(point) {
        if (requestDrawJoint && startJointPoint) {
            tempcanvas.selectAll('*').remove();

            /* */
            tempcanvas
                .append('line')
                .style('stroke', requestJointColor)
                .style('stroke-width', JOINT_LINE_WIDTH)
                .attr('x1', startJointPoint[0])
                .attr('y1', startJointPoint[1])
                .attr('x2', point[0])
                .attr('y2', point[1]);
            /* 화살 표시 : 현재는 사용하지 않는다 */
            // .attr('marker-end', function(d) {
            // 	return 'url(#arrow)';
            // })
        }

        /* [2025/05/25] added */
        if (requestFreeLineType === true && startFreeLinePoints.length > 0) {
            startFreeLinePoints.push({
                x: point[0],
                y: point[1]
            });

            /* */
            tempcanvas.selectAll('polyline').remove();
            tempcanvas
                .append('polyline')
                .style('stroke', requestFreeLineColor)
                .style('stroke-width', requestFreeLineWidth)
                .style('fill', 'transparent')
                .style('opacity', FREELINE_TRANSPARENT_OPACITY)
                .attr('points', function() {
                    return startFreeLinePoints
                        .map(function(d) {
                            return [d.x, d.y].join(',');
                        })
                        .join(' ');
                });
        }
        /* end of [2025/05/25] */
    }

    function onTouchEnd(point) {
        if (requestDrawJoint && startJointPoint) {
            var joint = {
                id: getUUID(),
                color: requestJointColor,
                x1: startJointPoint[0],
                y1: startJointPoint[1],
                x2: point[0],
                y2: point[1],
                angle: 180
            };

            /* */
            tempcanvas.selectAll('line').remove();
            /* */
            appendToJointDb(joint);
            drawJoint(joint);

            /* */
            releaseOperationIfNoKeep();
        } else if (requestFreeLineType === true) {
            /* [2025/05/25] added */
            /* */
            if (startFreeLinePoints.length > 0) {
                /* */
                tempcanvas.selectAll('polyline').remove();

                var freeline = {
                    id: getUUID(),
                    strokeWidth: requestFreeLineWidth,
                    strokeColor: requestFreeLineColor,
                    points: startFreeLinePoints
                };

                /* */
                appendToFreeLineDb(freeline);
                drawFreeLine(freeline);

                /* */
                releaseOperationIfNoKeep();
                return;
            }
        }

        startJointPoint = null;
        startFreeLinePoints = [];
    }

    /* 요청 상태를 초기화한다. */
    function clearRequestState(fromDelete) {
        requestDrawJoint = false;
        requestDrawRock = false;
        requestDrawWater = false;
        requestDrawText = false;

        /* [2021/03/27] 암종 */
        requestDrawType = false;

        /* [2025/05/25] added, 자유선 */
        requestFreeLineType = false;

        /* */
        if (fromDelete !== true) {
            requestRemoveObject = false;
        }

        tempcanvas.selectAll('*').remove();

        /* */
        if (_.isFunction(onChangedEraseEnable)) {
            onChangedEraseEnable(requestRemoveObject);
        }

        /* */
        enableZoom(true);
    }

    /* */
    function drawJoint(joint) {
        /* */
        var group = canvas.append('g').attr('id', joint.id);
        /* */
        group
            .append('line')
            .style('stroke', joint.color)
            .style('stroke-width', JOINT_LINE_WIDTH)
            .attr('x1', joint.x1)
            .attr('y1', joint.y1)
            .attr('x2', joint.x2)
            .attr('y2', joint.y2)
            /* 화살 표시 : 현재는 사용하지 않는다 */
            // .attr('marker-end', function(d) {
            // 	return 'url(#arrow)';
            // })
            .on('click', function() {
                if (requestRemoveObject === true) {
                    /* */
                    removeJointDbBy(joint.id);

                    /* */
                    if (isKeepSelectedOperation === true) {
                        redrawCanvas(true);
                    } else {
                        redrawCanvas();
                    }
                }
            });

        var center = getCenter(joint.x1, joint.y1, joint.x2, joint.y2);
        var points = getJointRectangle(joint.x1, joint.y1, joint.x2, joint.y2);
        var angle = getAngle(joint.x1, joint.y1, joint.x2, joint.y2) + joint.angle;
        group
            .append('polygon')
            .style('stroke', joint.color)
            .style('stroke-width', JOINT_LINE_WIDTH)
            .style('fill', joint.color)
            .attr('points', function() {
                return points
                    .map(function(d) {
                        return [d.x, d.y].join(',');
                    })
                    .join(' ');
            })
            .attr('transform', `rotate(${angle}, ${center.x}, ${center.y})`)
            .on('click', function() {
                if (requestRemoveObject === true) {
                    /* */
                    removeJointDbBy(joint.id);

                    /* */
                    if (isKeepSelectedOperation === true) {
                        redrawCanvas(true);
                    } else {
                        redrawCanvas();
                    }
                }
            })
            .on('dblclick', function() {
                if (joint.angle === 0) joint.angle = 180;
                else joint.angle = 0;

                redrawCanvas();
            });
    }

    /* */
    function drawRock(rock) {
        /* */
        var group = canvas.append('g').attr('id', rock.id);
        /* */
        group
            .append('polygon')
            .style('stroke', rock.color)
            .style('stroke-width', JOINT_LINE_WIDTH)
            .style('fill', rock.color)
            .style('opacity', ROCK_TRANSPARENT_OPACITY)
            .attr('points', function() {
                return rock.points
                    .map(function(d) {
                        return [d.x, d.y].join(',');
                    })
                    .join(' ');
            })
            .on('click', function() {
                if (requestRemoveObject === true) {
                    /* */
                    removeRockDbBy(rock.id);
                    /* */
                    if (isKeepSelectedOperation === true) {
                        redrawCanvas(true);
                    } else {
                        redrawCanvas();
                    }
                }
            });
    }

    /* [2025/05/25] added */
    function drawFreeLine(freeline) {
        /* */
        var group = canvas.append('g').attr('id', freeline.id);
        /* */
        group
            .append('polyline')
            .style('stroke', freeline.strokeColor)
            .style('stroke-width', freeline.strokeWidth)
            .style('fill', 'transparent')
            .style('opacity', FREELINE_TRANSPARENT_OPACITY)
            .attr('points', function() {
                return freeline.points
                    .map(function(d) {
                        return [d.x, d.y].join(',');
                    })
                    .join(' ');
            })
            .on('click', function() {
                if (requestRemoveObject === true) {
                    /* */
                    removeFreeLineDbBy(freeline.id);
                    /* */
                    if (isKeepSelectedOperation === true) {
                        redrawCanvas(true);
                    } else {
                        redrawCanvas();
                    }
                }
            });
    }
    /* end of [2025/05/25] */

    /* [2020/08/29] svg를 base64로 만들기 위해서는 image도 base64로 넣어주어야 한다. */
    var waterImageBase64Map = {};

    function initImageToBase64() {
        /* 주소는 조정이 필요할 수 있음 */
        /*
        var dampurl     = "../assets/images/editor/editor-func-3-1.png";
        var weturl      = "../assets/images/editor/editor-func-3-2.png";
        var drippingurl = "../assets/images/editor/editor-func-3-3.png";
        var flowingurl  = "../assets/images/editor/editor-func-3-4.png";
        */
        var dampurl = '/images/common/bg_jiha_1.png';
        var weturl = '/images/common/bg_jiha_2.png';
        var drippingurl = '/images/common/bg_jiha_3.png';
        var flowingurl = '/images/common/bg_jiha_4.png';

        convertImgURLToDataURL(dampurl, function(base64, width, height) {
            waterImageBase64Map['damp'] = base64;
        });

        convertImgURLToDataURL(weturl, function(base64, width, height) {
            waterImageBase64Map['wet'] = base64;
        });

        convertImgURLToDataURL(drippingurl, function(base64, width, height) {
            waterImageBase64Map['dripping'] = base64;
        });

        convertImgURLToDataURL(flowingurl, function(base64, width, height) {
            waterImageBase64Map['flowing'] = base64;
        });
    }

    /* */
    function drawWater(water) {
        /* */
        var group = canvas.append('g').attr('id', water.id);

        /* [2020/08/29] svg를 base64로 만들기 위해서는 image도 base64로 넣어주어야 한다. */
        var imgUrl = waterImageBase64Map[water.icon] || '';
        if (imgUrl.length === 0) {
            imgUrl = waterImageBase64Map['damp'] || '';
        }

        var half = WATER_ICON_SIZE / 2;
        /* */
        group
            .append('svg:image')
            .attr('xlink:href', imgUrl)
            .attr('x', water.x - half)
            .attr('y', water.y - half)
            .attr('width', WATER_ICON_SIZE)
            .attr('height', WATER_ICON_SIZE)
            .on('click', function() {
                if (requestRemoveObject === true) {
                    /* */
                    removeWaterDbBy(water.id);
                    /* */
                    if (isKeepSelectedOperation === true) {
                        redrawCanvas(true);
                    } else {
                        redrawCanvas();
                    }
                }
            });
    }

    /* */
    function drawText(text) {
        /* */
        var group = canvas.append('g').attr('id', text.id);

        /* */
        group
            .append('text')
            .text(function() {
                return text.text;
            })
            .attr('x', text.x)
            .attr('y', text.y)
            .attr('font-size', text.fontSize || TEXT_FONT_SIZE)
            .attr('fill', text.fontColor || TEXT_FONT_COLOR)
            .attr('text-anchor', TEXT_FONT_ANCHOR)
            .on('click', function() {
                if (requestRemoveObject === true) {
                    /* */
                    removeTextDbBy(text.id);
                    /* */
                    if (isKeepSelectedOperation === true) {
                        redrawCanvas(true);
                    } else {
                        redrawCanvas();
                    }
                }
            });
    }

    /* [2024/06/17] */
    function makeTypePatternId(originId) {
        return originId + typePatternPrefix;
    }
    /* end of [2024/06/17] */

    /* */
    function loadRockTypePatternWithSvg(id, svgUrl) {
        var url = svgUrl.replace('/assets/images', '/images');
        //d3.xml(FILE_URL + svgUrl, { crossOrigin: 'anonymous' }).then(data => {
        /* [2024/06/17] id to makeTypePatternId(id) */
        d3.xml(url, { crossOrigin: 'anonymous' }).then(data => {
            defs.append('pattern')
                .attr('id', makeTypePatternId(id))
                .attr('patternUnits', 'userSpaceOnUse')
                .attr('patternContentUnits', 'objectBoundingBox')
                .attr('width', '35')
                .attr('height', '35')
                .attr('x', 0)
                .attr('y', 0)
                .attr('viewBox', '0,0,65,65')
                .node()
                .append(data.documentElement);
        });
    }

    /* 암종 패턴 */
    function loadRockTypePatterns() {
        //images/rocktype  <-> /assets/images/svg
        /*
        loadRockTypePatternWithSvg('granite', '/assets/images/svg/granite.svg');
        loadRockTypePatternWithSvg('diorite', '/assets/images/svg/diorite.svg');
        loadRockTypePatternWithSvg('gabbro', '/assets/images/svg/gabbro.svg');
        loadRockTypePatternWithSvg('rhyolite', '/assets/images/svg/rhyolite.svg');
        loadRockTypePatternWithSvg('andesite', '/assets/images/svg/andesite.svg');
        loadRockTypePatternWithSvg('basalt', '/assets/images/svg/basalt.svg');
        loadRockTypePatternWithSvg('porphyry', '/assets/images/svg/porphyry.svg');
        loadRockTypePatternWithSvg('tuff', '/assets/images/svg/tuff.svg');
        loadRockTypePatternWithSvg('dyke', '/assets/images/svg/dyke.svg');
        loadRockTypePatternWithSvg('phyllite', '/assets/images/svg/phyllite.svg');
        loadRockTypePatternWithSvg('schist', '/assets/images/svg/schist.svg');
        loadRockTypePatternWithSvg('gneiss', '/assets/images/svg/gneiss.svg');
        loadRockTypePatternWithSvg('marble', '/assets/images/svg/marble.svg');
        loadRockTypePatternWithSvg('dolomite', '/assets/images/svg/dolomite.svg');
        loadRockTypePatternWithSvg('quartzite', '/assets/images/svg/quartzite.svg');
        loadRockTypePatternWithSvg('mudstone', '/assets/images/svg/mudstone.svg');
        loadRockTypePatternWithSvg('shale', '/assets/images/svg/shale.svg');
        loadRockTypePatternWithSvg('sandstone', '/assets/images/svg/sandstone.svg');
        loadRockTypePatternWithSvg('conglomerate', '/assets/images/svg/conglomerate.svg');
        loadRockTypePatternWithSvg('limestone2', '/assets/images/svg/limestone2.svg');
        */

        loadRockTypePatternWithSvg('granite', '/images/rocktype/granite.svg');
        loadRockTypePatternWithSvg('diorite', '/images/rocktype/diorite.svg');
        loadRockTypePatternWithSvg('gabbro', '/images/rocktype/gabbro.svg');
        loadRockTypePatternWithSvg('rhyolite', '/images/rocktype/rhyolite.svg');
        loadRockTypePatternWithSvg('andesite', '/images/rocktype/andesite.svg');
        loadRockTypePatternWithSvg('basalt', '/images/rocktype/basalt.svg');
        loadRockTypePatternWithSvg('porphyry', '/images/rocktype/porphyry.svg');
        loadRockTypePatternWithSvg('tuff', '/images/rocktype/tuff.svg');
        loadRockTypePatternWithSvg('dyke', '/images/rocktype/dyke.svg');
        loadRockTypePatternWithSvg('phyllite', '/images/rocktype/phyllite.svg');
        loadRockTypePatternWithSvg('schist', '/images/rocktype/schist.svg');
        loadRockTypePatternWithSvg('gneiss', '/images/rocktype/gneiss.svg');
        loadRockTypePatternWithSvg('marble', '/images/rocktype/marble.svg');
        loadRockTypePatternWithSvg('dolomite', '/images/rocktype/dolomite.svg');
        loadRockTypePatternWithSvg('quartzite', '/images/rocktype/quartzite.svg');
        loadRockTypePatternWithSvg('mudstone', '/images/rocktype/mudstone.svg');
        loadRockTypePatternWithSvg('shale', '/images/rocktype/shale.svg');
        loadRockTypePatternWithSvg('sandstone', '/images/rocktype/sandstone.svg');
        loadRockTypePatternWithSvg('conglomerate', '/images/rocktype/conglomerate.svg');
        loadRockTypePatternWithSvg('limestone2', '/images/rocktype/limestone2.svg');

        loadRockTypePatternWithSvg('pattern1', '/images/rocktype/pattern1.svg');
        loadRockTypePatternWithSvg('pattern2', '/images/rocktype/pattern2.svg');
        loadRockTypePatternWithSvg('pattern3', '/images/rocktype/pattern3.svg');
        loadRockTypePatternWithSvg('pattern4', '/images/rocktype/pattern4.svg');
        loadRockTypePatternWithSvg('pattern5', '/images/rocktype/pattern5.svg');
    }

    /* */
    function drawType(type) {
        console.log('[*] drawType:', type);

        /* */
        var group = canvas.append('g').attr('id', type.id);
        /* */
        /* [2024/06/17] type.pattern to makeTypePatternId(type.pattern) */
        group
            .append('polygon')
            .style('stroke', DEFAULT_TYPE_COLOR)
            .style('stroke-width', JOINT_LINE_WIDTH)
            .style('fill', 'url(#' + makeTypePatternId(type.pattern) + ')')
            .style('opacity', ROCK_TRANSPARENT_OPACITY_ROW)
            .attr('points', function() {
                return type.points
                    .map(function(d) {
                        return [d.x, d.y].join(',');
                    })
                    .join(' ');
            })
            .on('click', function() {
                if (requestRemoveObject === true) {
                    /* */
                    removeTypeDbBy(type.id);

                    console.log('[*] drawType remove:', type, types, rocks);
                    /* */
                    if (isKeepSelectedOperation === true) {
                        redrawCanvas(true);
                    } else {
                        redrawCanvas();
                    }
                }
            });
    }

    /* [2020/08/29] svg를 base64로 만들기 위해서는 image도 base64로 넣어주어야 한다. */
    function redrawBackground(imgurl) {
        /* */
        convertImgURLToDataURL(imgurl, function(base64, width, height) {
            redrawBackgroundOnD3(imgurl, base64, width, height);
        });
    }

    /* */
    function redrawBackgroundOnD3(imgurl, base64, width, height) {
        /*
         * 이미지의 width, height는 필요시 사용
         */

        //if (width > 1440) width = 1440;
        //if (width > 890) width = 890;
        //if (height > 790) height = 790;
        if (height > 650) height = 650;

        background.selectAll('image').remove();
        background
            .append('svg:image')
            .attr('id', 'id-background')
            /*
             * svg를 base64로 만들기 위해서는 image도 base64로 넣어주어야 한다.
             * .attr("xlink:href", imgurl)
             */
            .attr('xlink:href', base64)
            .attr('x', 0)
            .attr('y', 0)
            .attr('height', height);
        //.attr("height", height);

        /* */
        // imageRect = {
        //     top: 0,
        //     left: 0,
        //     width: width,
        //     height: height
        // };
    }

    /*****************************************************************
     * canvas control
     */

    /* */
    function clearCanvas(fromDelete) {
        canvas.selectAll('*').remove();
        tempcanvas.selectAll('*').remove();
        /* */
        clearRequestState(fromDelete);
    }

    /* */
    function redrawCanvas(fromDelete) {
        clearCanvas(fromDelete);

        /* */
        redrawBackground(apiResponse.imgurl);

        $.each(rocks, function(index, rock) {
            drawRock(rock);
        });

        /* [2021/03/27] 암종 */
        $.each(types, function(index, type) {
            drawType(type);
        });

        $.each(waters, function(index, water) {
            drawWater(water);
        });

        $.each(texts, function(index, text) {
            drawText(text);
        });

        /* [2025/05/25] added */
        $.each(freelines, function(index, freeline) {
            drawFreeLine(freeline);
        });
        /* end of [2025/05/25] */

        $.each(joints, function(index, joint) {
            drawJoint(joint);
        });
    }

    /* draw joint */
    function startDrawJointLine(color) {
        enableZoom(false);

        /* */
        requestDrawJoint = true;
        requestJointColor = color || 'black';
        startJointPoint = null;
    }

    /* draw rock polygon */
    function startDrawRockPolygon(color) {
        enableZoom(false);
        /* */
        requestDrawRock = true;
        requestRockColor = color || 'black';
        startRockPoints = [];
    }

    /* water icon */
    function startDrawWaterIcon(icon) {
        enableZoom(false);
        /* */
        requestDrawWater = true;
        requestWaterIcon = icon || 'damp';
    }

    /* TEXT */
    function startDrawText(fontSize, fontColor, autoText) {
        enableZoom(false);
        /* */
        requestDrawText = true;
        /* */
        textFontSize = fontSize;
        textFontColor = fontColor;
        textAutoText = autoText;
    }

    /* draw rock type polygon */
    function startDrawTypePatternPolygon(pattern) {
        enableZoom(false);
        /* */
        requestDrawType = true;
        ///requestTypePattern = pattern || 'granite';
        requestTypePattern = pattern || 'pattern1';
        startTypePoints = [];
    }

    /* FREE LINE */
    function startDrawFreeLine(width, color) {
        console.log('[*] start freeline');

        enableZoom(false);
        /* */
        requestFreeLineType = true;
        requestFreeLineWidth = width || FREELINE_DEFAULT_STROKE_WIDTH;
        requestFreeLineColor = color || TEXT_FONT_COLOR;
        startFreeLinePoints = [];
    }

    /* remove */
    function startRemoveObject(enable) {
        requestRemoveObject = enable;

        /* */
        if (_.isFunction(onChangedEraseEnable)) {
            onChangedEraseEnable(enable);
        }
    }

    /* undo */
    function undoCanvas() {
        /* */
        doUndoOnHistoryDb();

        /* */
        redrawCanvas();
    }

    /* redo */
    function redoCanvas() {
        /* */
        doRedoOnHistoryDb();
        /* */
        redrawCanvas();
    }

    /* */
    function releaseOperationIfNoKeep() {
        if (isKeepSelectedOperation !== true) {
            clearRequestState();
            /* */
            if (_.isFunction(onReleaseRequestOperation)) {
                onReleaseRequestOperation();
            }
        }
    }

    /**************************************************************************** */
    /* exports */
    /* [2024/06/17] added patternPrefix*/
    exports.initCanvas = function(id, selector, patternPrefix) {
        masterId = id;
        rootSelector = selector;

        /* [2024/06/17] */
        typePatternPrefix = '';
        if (patternPrefix) {
            typePatternPrefix = '_' + patternPrefix;
        }
        /* end of [2024/06/17] */

        /* */
        initImageToBase64();
        /* */
        initD3();

        /*
        window.addEventListener('resize', function() {
            redrawCanvas();
        });
        */
    };

    /* */
    exports.initData = function(data, facemappingType) {
        initData(data, facemappingType);
    };

    /* */
    exports.setOnChangedZoomEnable = function(cb) {
        if (_.isFunction(cb)) {
            onChangedZoomEnable = cb;
        }
    };
    /* */
    exports.setOnChangedEraseEnable = function(cb) {
        if (_.isFunction(cb)) {
            onChangedEraseEnable = cb;
        }
    };
    /* 요청이 유지되지 않고 단건으로 처리될 경우, 처리가 완료되었음을 알려준다. */
    exports.setOnReleaseRequestOperation = function(cb) {
        if (_.isFunction(cb)) {
            onReleaseRequestOperation = cb;
        }
    };

    /* */
    exports.setFrontImageUrl = function(imgUrl) {
        apiResponse.imgurl = imgUrl; //frontImageOriginUrl;
        redrawCanvas();
    };

    /* 초기화 */
    exports.reset = function() {
        if (confirm('초기화 하신 후 에는 데이터는 원복할 수 없습니다. 진행하시겠습니까?')) {
            clearDbAll();
            clearCanvas();
        }
    };

    /* 이전 */
    exports.undo = function() {
        clearRequestState();
        undoCanvas();
    };

    /* 재실행 */
    exports.redo = function() {
        clearRequestState();
        redoCanvas();
    };

    /* 지우개 */
    exports.enableErase = function(enable) {
        clearRequestState();
        startRemoveObject(enable);
    };

    /* 지우개 */
    exports.enableZoom = function(enable) {
        clearRequestState();
        enableZoom(enable);
    };

    /* 현재의 연산을 계속 유지할지 여부 */
    exports.enableKeepSelectedOperation = function(enable) {
        isKeepSelectedOperation = enable;
    };

    /* 절리 그리기 */
    exports.drawJointLine = function(color) {
        clearRequestState();
        startDrawJointLine(color);
    };

    /* 암질 그리기 */
    exports.drawRockPolygon = function(color) {
        clearRequestState();
        startDrawRockPolygon(color);
    };

    /* 지하수 그리기 */
    exports.drawWaterIcon = function(icon) {
        clearRequestState();
        startDrawWaterIcon(icon);
    };

    /* 텍스트*/
    exports.drawText = function(fontSize, fontColor, autoText) {
        clearRequestState();
        startDrawText(fontSize, fontColor, autoText);
    };

    /* 자유선 */
    exports.drawFreeLine = function(width, color) {
        clearRequestState();
        startDrawFreeLine(width, color);
    };
    /* [2024/06/22] deprecated */
    exports.updateFreeLine = function(width, color) {
        requestFreeLineWidth = width || FREELINE_DEFAULT_STROKE_WIDTH;
        requestFreeLineColor = color || TEXT_FONT_COLOR;
    };

    /* 암질 그리기 */
    exports.drawTypePatternPolygon = function(pattern) {
        clearRequestState();
        startDrawTypePatternPolygon(pattern);
    };

    /* */
    exports.dumpDbAll = function() {
        return dumpDbAll();
    };

    /* */
    exports.fileDelete = function() {
        /* */
        /* */
        this.setFrontImageUrl('');
        $('#id-background').attr('href', '');
        clearDbAll();
        clearCanvas();
    };

    /* [2024/05/25] modified, added facemapping type */
    exports.saveImage = function(facemappingType /* FM or GS or GS2 */, successCb, errorCb) {
        if (_.isFunction(successCb) === false) return;

        /* */
        var db = dumpDbAll();
        /* [2024/05/25] object로 전달한다.*/
        /*
         * var rockJudgmentObj = JSON.stringify(db);
         */

        const base64 = getImageBase64OfCurrentSvg();
        const cbFunction = function(pngData) {
            const blob = base64ToBlob(pngData);

            //const type = blob.type.split('/')[1];
            /* [2024/05/25] added facemappingType(FM, GS) */
            const imageName = isNullEmpty(rockJudgmentName)
                ? 'STA NO_' + new Date().getTime() + '.png'
                : 'STA NO_' + rockJudgmentName + '_' + facemappingType + '.png'; //구간명은 어떨까 STA_XXX-XXX

            const formData = new FormData();
            formData.append('file_id', '');
            formData.append('file_name', imageName);
            formData.append('file', blob);

            FileApi.blolImgUpload(formData).then(res => {
                /* [2024/05/25] rockJudgmentObj to db */
                successCb(db, res.content.fileId);
            });
        };
        if (facemappingType === 'GS2') {
            svgUrlToGsPng(base64, cbFunction);
        } else svgUrlToPng(base64, cbFunction);
    };

    /* [2024/05/25] added */
    exports.disableZoomForcibly = function() {
        disableZoomForcibly();
    };
    /* end of [2024/05/25] */

    /// [2024/06/17] added wwweojin
    exports.isDrawFreeLineSelected = function() {
        return requestFreeLineType;
    };

    exports.isDrawTextSelected = function() {
        return requestDrawText;
    };

    /* */
    return exports;
}
